let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5bUAX")).then(() => parcelRequire('1bnFN'));